import useAuth from "src/hooks/useAuth";
import useSWR from "swr";
import { fetcher } from "src/api/API";

const useGetGrantedSubAccounts = selectedGroups => {
    const { getAccessToken } = useAuth();
    const { data, error, mutate } = useSWR(["granted_subaccounts", getAccessToken], fetcher, {
        revalidateOnFocus: false,
    });

    let subAccounts = [];
    if (data && data?.length && selectedGroups?.length) {
        subAccounts = data
            .filter(accounts => selectedGroups.includes(accounts.groupName))
            ?.map(a => a.subAccountNamesAndRoles.map(acct => acct.name))
            .flat();
    } else if (data && data?.length && !selectedGroups?.length) {
        subAccounts = data.map(a => a.subAccountNamesAndRoles.map(acct => acct.name)).flat();
    }

    let errorMsg = "";
    if (error && error.response?.data) {
        errorMsg =
            error.response.data?.message === "No message available"
                ? `Error: ${error.response.data.error}`
                : `Error: ${error.response.data.message}`;
    } else if (error && !error.response?.data) {
        errorMsg = "Error";
    }

    return {
        data: !error ? subAccounts : [],
        isLoading: !error && !data,
        isError: errorMsg,
        mutate,
    };
};

export default useGetGrantedSubAccounts;
